//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//login
export const API_USER_LOGIN = "/api/user/login-admin";
export const API_GET_IP_USER = "https://api.ipify.org?format=json";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

//Image
export const API_IMAGE_INSERT = "/api/upload/image";
export const API_IMAGE_DELETE = "/api/upload/delete/image";
export const API_IMAGE_GET_BY_ID = "/uploads/images";

//CV
export const API_CV_INSERT = "/api/upload/cv";
export const API_CV_DELETE = "/api/upload/delete/cv";
export const API_CV_GET_BY_ID = "/uploads/cv";

//File
export const API_FILE_INSERT = "/api/file/upload";

//User
export const API_USER_INSERT = "/api/user/insert";
export const API_USER_UPDATE = "/api/user/update";
export const API_USER_DELETE = "/api/user/delete";
export const API_USER_GET_PAGING = "/api/user/getPaging";
export const API_USER_GET_ALL = "/api/user/getAll";
export const API_USER_GET_INFO_BY_ID = "/api/user/getUserInfoById";
export const API_USER_DELETE_MANY = "/api/user/deleteMany";
export const API_USER_GET_MANAGEMENT = "/api/user/getManagementUser";
export const API_USER_GET_BY_ID = "/api/user/getById";
export const API_USER_UPDATE_DEPARTMENT = "/api/user/updateDepartment";

//Role
export const API_ROLE_INSERT = "/api/role/insert";
export const API_ROLE_UPDATE = "/api/role/update";
export const API_ROLE_DELETE = "/api/role/delete";
export const API_ROLE_GETALL = "/api/role/getAll";
export const API_ROLE_GET_PAGING = "/api/role/getPaging";
export const API_ROLE_GET_PAGING_BY_ID = "/api/role/getById";
export const API_ROLE_GET_MENU_BY_ID = "/api/role/getMenuById";
export const API_ROLE_DELETE_MANY = "/api/role/deleteMany";
export const API_ROLE_GET_MANAGEMENT = "/api/role/getManagementRole";

//Action
export const API_ACTION_INSERT = "/api/action/insert";
export const API_ACTION_UPDATE = "/api/action/update";
export const API_ACTION_DELETE = "/api/action/delete";
export const API_ACTION_GETALL = "/api/action/getAll";
export const API_ACTION_GET_PAGING = "/api/action/getPaging";
export const API_ACTION_GET_PAGING_BY_ID = "/api/action/getById";

//Department
export const API_DEPARTMENT_INSERT = "/api/department/insert";
export const API_DEPARTMENT_UPDATE = "/api/department/update";
export const API_DEPARTMENT_DELETE = "/api/department/delete";
export const API_DEPARTMENT_GET_PAGING = "/api/department/getPaging";
export const API_DEPARTMENT_GET_ALL = "/api/department/getAll";
export const API_DEPARTMENT_GET_PAGING_BY_ID = "/api/department/getById";
export const API_DEPARTMENT_DELETE_MANY = "/api/department/deleteMany";
export const API_DEPARTMENT_GET_MANAGEMENT =
  "/api/department/getManagementDepartment";

//Shift
export const API_SHIFT_INSERT = "/api/shift/insert";
export const API_SHIFT_UPDATE = "/api/shift/update";
export const API_SHIFT_DELETE = "/api/shift/delete";
export const API_SHIFT_DELETE_PERIOD = "/api/shift/deletePeriod";
export const API_SHIFT_GET_PAGING = "/api/shift/getPaging";
export const API_SHIFT_GET_PAGING_BY_ID = "/api/shift/getById";
export const API_SHIFT_DELETE_MANY = "/api/shift/deleteMany";
export const API_SHIFT_GET_MANAGEMENT = "/api/shift/getManagementShift";
//Attendance
export const API_ATTENDANCES_INSERT = "/api/attendance/insert";
export const API_ATTENDANCES_UPDATE = "/api/attendance/update";
export const API_ATTENDANCES_DELETE = "/api/attendance/delete";
export const API_ATTENDANCES_GET_PAGING = "/api/attendance/getPaging";
export const API_ATTENDANCES_GET_PAGING_BY_ID = "/api/attendance/getById";

//Application
export const API_APPLICATION_INSERT = "/api/application/insert";
export const API_APPLICATION_UPDATE = "/api/application/update";
export const API_APPLICATION_DELETE = "/api/application/delete";
export const API_APPLICATION_GET_PAGING_BY_ID = "/api/application/getById";
export const API_APPLICATION_GET_PAGING = "/api/application/getPaging";
export const API_APPLICATION_DELETE_MANY = "/api/application/deleteMany";
export const API_APPLICATION_GET_MANAGEMENT =
  "/api/application/getManagementApplication";

//Logs
export const API_HISTORY_UPDATE = "/api/history/update";
export const API_HISTORY_DELETE = "/api/history/delete";
export const API_HISTORY_GETALL = "/api/history/getAll";
export const API_HISTORY_GET_PAGING = "/api/history/getPaging";
export const API_HISTORY_GET_PAGING_BY_ID = "/api/history/getById";
export const API_GET_SAME_IP = "/api/duplicatedLog/ip";
export const API_GET_SAME_FP = "/api/duplicatedLog/fp";
export const API_GET_SAME_FP_IP = "/api/duplicatedLog/ip-and-fp";
// old
export const API_GET_SAME_IP_OLD = "/api/history/getSameIp";
export const API_GET_SAME_FP_OLD = "/api/history/getSameFp";
export const API_HISTORY_DELETE_MANY = "/api/history/deleteMany";
//Group
export const API_GROUP_INSERT = "/api/group/insert";
export const API_GROUP_GET_ALL = "/api/group/getAll";
export const API_GROUP_UPDATE = "/api/group/update";
export const API_GROUP_DELETE = "/api/group/delete";
export const API_GROUP_GET_PAGING = "/api/group/getPaging";
export const API_GROUP_DELETE_MANY = "/api/group/deleteMany";
export const API_GROUP_GET_MANAGEMENT = "/api/group/getManagementGroup";

//Company
export const API_COMPANY_INSERT = "/api/company/insert";
export const API_COMPANY_GET_ALL = "/api/company/getAll";
export const API_COMPANY_UPDATE = "/api/company/update";
export const API_COMPANY_DELETE = "/api/company/delete";
export const API_COMPANY_GET_PAGING = "/api/company/getPaging";
export const API_COMPANY_DELETE_MANY = "/api/company/deleteMany";
export const API_COMPANY_GET_MANAGEMENT = "/api/company/getManagementCompany";

//Action
export const API_ACTION_HISTORY_DELETE = "/api/actionHistory/delete";
export const API_ACTION_HISTORY_DELETE_INTERVAL =
  "/api/actionHistory/deleteInterval";
export const API_ACTION_HISTORY_DELETE_MANY = "/api/actionHistory/deleteMany";
export const API_ACTION_HISTORY_GET_PAGING = "/api/actionHistory/getPaging";
export const API_ACTION_HISTORY_GET_PAGING_BY_ID = "/api/actionHistory/getById";
export const API_ACTION_HISTORY_GET_MANAGEMENT =
  "/api/actionHistory/getManagementActionHistory";

//Dashboard
export const API_DASHBOARD_EMPLOYEE_POST = "/api/dashboard/dashboard-employee";
export const API_DASHBOARD_EMPLOYEE_IN_YEAR_POST =
  "/api/dashboard/dashboard-employee-in-year";
export const API_DASHBOARD_APPLICAITON_POST =
  "/api/dashboard/dashboard-application";
export const API_DASHBOARD_HISTORY_POST = "/api/dashboard/dashboard-history";

//Bot
export const API_BOT = "/api/group-and-bot";
//Send Message
export const API_SEND_MESSAGE = "/api/group-and-bot/sendMessage";

//Message
export const API_MESSAGE = "/api/messages";

//Rules
export const API_GET_ALL_RULE = "/api/rules/getAll";
export const API_RULE_INSERT = "/api/rules/insert";
export const API_RULE_UPDATE = "/api/rules/update";

//Notify
export const API_NOTIFY = "/api/notify";
export const API_CREATGE_NOTIFY = "/api/notify/insert";
export const API_UPDATE_NOTIFY = "/api/notify/update";
export const API_DELETE_NOTIFY = "/api/notify/delete";
export const API_GET_NOTIFY = "/api/notify/getPaging";
